
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/monthlyTop10",
      function () {
        return require("private-next-pages/monthlyTop10.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/monthlyTop10"])
      });
    }
  